module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/core-js/library/modules/_html.js
// module id = 405
// module chunks = 0